import useBankDetailsManage from '../hooks/useBankDetailsManage';
import BankInfo from './BankInfo';
import AddList from '../../../../../../components/Dialog/AddList';
import AddBankDetail from '../../../../user-dashboard/settings/bank-details/AddBankDetail';
import LoadingSpinner from '../../../../../../animation/LoadingSpinner';

function BankDetailsManage() {
    const { 
        bankDetails, 
        isOpenBankModal, 
        setIsOpenBankModal,
        loading
    } = useBankDetailsManage();

    return (
        <div className="user-profile-main-container">
            {loading && <LoadingSpinner message="Loading bank details..." />}
            
            {!isOpenBankModal && bankDetails?.data?.length === 0 && (
                <AddList
                    heading="No bank details added!"
                    desc1="No bank details have been added yet."
                    desc2=""
                    buttonText="Add Bank Details"
                    onClick={() => setIsOpenBankModal(true)}
                />
            )}

            {bankDetails?.data?.length > 0 && <BankInfo />}

            {isOpenBankModal && <AddBankDetail onClose={() => setIsOpenBankModal(false)} />}
        </div>
    );
}

export default BankDetailsManage;